import { useState, useEffect } from 'react';
import { useProfileFetcher } from './profiles/useProfileFetcher';
import { useProfileManagement } from './profiles/useProfileManagement';
import { useProfileSubscription } from './profiles/useProfileSubscription';

// Define and export the ProfileData interface
export interface ProfileData {
  id: string;
  username: string | null;
  email?: string | null;
  avatar_url: string | null;
  bio: string | null;
  profession: string | null;
  location: string | null;
  years_experience: number | null;
  education: string | null;
  portfolio_url: string | null;
  website_url: string | null;
  linkedin_username: string | null;
  twitter_username: string | null;
  instagram_username: string | null;
  skills: string[] | null;
  languages: string[] | null;
  created_at?: string | null;
  updated_at?: string | null;
  is_admin?: boolean;
  portfolio_items: PortfolioItem[];
  experience_items: ExperienceItem[];
  view_count?: number;
  like_count?: number;
  is_liked?: boolean;
  username_slug?: string | null;
  derivedProfession?: string | null;
  display_name?: string | null;
  is_featured?: boolean;
  hireMeEnabled?: boolean;
}

// Re-export these types to maintain backward compatibility
import { PortfolioItem, ExperienceItem } from '@/hooks/useProfile';

export const useProfiles = () => {
  const [profiles, setProfiles] = useState<ProfileData[]>([]);
  const [loading, setLoading] = useState(true);
  
  // Use the new, smaller hooks
  const { fetchProfiles } = useProfileFetcher(setProfiles, setLoading);
  const { deleteUser } = useProfileManagement(profiles, setProfiles);
  
  // Set up subscription for real-time updates
  useProfileSubscription(fetchProfiles);
  
  // Fetch profiles on initial load
  useEffect(() => {
    fetchProfiles();
  }, [fetchProfiles]);

  return {
    profiles,
    loading,
    deleteUser,
    refreshProfiles: fetchProfiles
  };
};
